import { render, staticRenderFns } from "./AddMapping.vue?vue&type=template&id=22ec22c5&scoped=true"
import script from "./AddMapping.vue?vue&type=script&lang=js"
export * from "./AddMapping.vue?vue&type=script&lang=js"
import style0 from "./AddMapping.vue?vue&type=style&index=0&id=22ec22c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec22c5",
  null
  
)

export default component.exports